<template>
  <div class="mstation-introduce-background">
    <div class="mstation-introduce-banner">
      <div class="mstation-introduce-container">
        <div class="mstation-introduce-banner-title">学术教育方案</div>
      </div>

      <img class="mstation-introduce-banner-img" src="../../assets/about/banner.png">
    </div>
    <div class="mstation-introduce-container">

     <div class="mstation-introduce-content">
       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">一站式材料计算服务</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">
         <p class="mstation-introduce-content-info-text">
          龙讯旷腾自主开发了第一性原理计算软件PWmat、PWmat前后处理工具软件PWkit、
          PWmat在线可视化提交任务软件Q-Flow、浏览器端在线原子尺度建模软件Q-Studio、开源机器学习力场软件PWmat-MLFF等软件产品,致力于为高校用户提供从原子尺度建模到材料性质计算、数据可视化以及使用培训的一站式材料计算服务，让用户可以快速轻松上手材料计算。</p>
        <div class="mstation-introduce-content-img">
         <img class="mstation-introduce-content-img-png" src="../../assets/solution/one-stop.png">
       </div>
       <p class="mstation-introduce-content-info-text"> 同时龙讯旷腾也推出了预装所有上述软件产品的4卡GPU服务器Mstation，用户可开箱即用。除了一体机Mstation，龙讯旷腾还推出了SaaS化解决方案Mcloud。Mcloud是龙讯旷腾自建高性能集群和云桌面组成的云平台，云平台集成龙讯旷腾所有软件产品，租机时即可使用。针对上述软件产品，龙讯旷腾均有配套培训服务和售后支持服务，购买上述任何龙讯产品
          即可享受免费培训服务，培训包括基础课程、进阶课程和专题课程，适用不同基础用户。</p>



       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">解决方案</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-info">

         <table class="mstation-introduce-table">
           <tr class="mstation-introduce-th">
             <th class="mstation-introduce-text-th">方案类型</th>
             <th class="mstation-introduce-text-th">方案优势</th>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">单独软件License</td>
             <td class="mstation-introduce-text-td">免费安装和升级软件，提供软件使用培训和售后支持服务</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">一体机Mstation</td>
             <td class="mstation-introduce-text-td">预装龙讯所有软件产品，以及机器管理和作业调度软件，用户可开箱即用，提供培训和售后支持</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">双机互联Mstation</td>
             <td class="mstation-introduce-text-td">两台单机版Mstation直接ib网线互联组成轻量化的集群,具有高性价比特点，提供培训和售后支持</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">集群化Mcluster</td>
             <td class="mstation-introduce-text-td">由多台MStation、存储服务器及管理节点组成，预装龙讯所有软件、集群管理软件及客户需求开源软件</td>
           </tr>
           <tr class="mstation-introduce-td">
             <td class="mstation-introduce-text-td">机时租赁Mcloud</td>
             <td class="mstation-introduce-text-td">租赁龙讯超算云Mcloud机时即可使用所有龙讯软件产品，具有随租随用、资源丰富、可扩展性强等特点</td>
           </tr>
         </table>
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">应用案例</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="mstation-introduce-content-img">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper1.png">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper2.png">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper3.png">
         <img class="paper-introduce-content-img-png" src="../../assets/solution/paper4.png">
       </div>

       <div class="mstation-introduce-content-title">
         <div class="mstation-introduce-content-title-text">合作高校</div>
         <div class="mstation-introduce-line"></div>
       </div>
       <div class="home-cooperate-list">
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_1.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_2.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_3.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_4.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_5.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_6.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_7.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_8.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_9.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_10.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_11.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_12.png"></div>
      </div>

 
     </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "companyIntroduce"
  }
</script>

<style scoped>
  .mstation-introduce-container {
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .mstation-introduce-background{
    margin-top: 70px;
  }
  .mstation-introduce-banner{
    overflow:hidden;
  }
  .mstation-introduce-banner-title{
    font-size:24px;
    font-family:PingFangSC-Semibold,sans-serif;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:50px;
    position: absolute;
    margin-top: 60px;
  }
  .mstation-introduce-banner-img{
    min-width:100%;
    height:165px;
  }
  .mstation-introduce-content{
    margin-top: 30px;
    margin-bottom: 90px;
  }
  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-img-png{
    margin-top: 10px;
    margin-bottom: 50px;
    width: 100%;
  }
  .paper-introduce-content-img-png{
    margin-top: 10px;
    margin-bottom: 30px;
    width: 100%;
  }
  .mstation-introduce-content-title{
    padding-top: 50px;
  }
  .mstation-introduce-content-title-text{
    font-size:30px;
    font-family:PingFangSC-Medium,sans-serif;
    font-weight:500;
    color:rgba(73,145,201,1);
    line-height:50px;
  }
  .mstation-introduce-content-info{
    margin-top: 40px;
  }
  .mstation-introduce-content-info-text{
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(79,76,77,1);
    line-height:30px;
  }
  .mstation-introduce-line{
    height:1px;
    background:rgba(240,240,240,1);
    margin-top: 8px;
  }
  .mstation-introduce-table{
    width: 100%;
    border:1px solid rgba(240,240,240,1);
  }
  .mstation-introduce-th{
    background:rgba(73,145,201,1);
    height: 45px;
  }
  .mstation-introduce-td{
    height: 45px;
  }
  .mstation-introduce-td:hover{
    background:rgba(73,145,201,0.1);
  }
  .mstation-introduce-text-th{
    border:1px solid rgba(240,240,240,1);
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-text-td{
    border:1px solid rgba(240,240,240,1);
    font-size:18px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    line-height:25px;
    padding-left: 16px;
  }
  .mstation-introduce-fa{
    font-size: 16px;
    padding-right: 8px;
  }

  .solution-border {
      width: 182px;
      height: 400px;
      margin: 30px 5px 0 5px;
      background-color:rgb(211, 211, 226)
    }
    .home-cooperate-list{
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 60px;
  }
  .home-cooperate-img-div{
    width: 200px;
    height: 90px;
    margin: 30px 15px 0px 15px;
    padding: 15px 0;
    display: inline-block;
    text-align: center;
  }
  .home-cooperate-img{
    max-width: 220px;
    max-height: 60px;
  }

  .mstation-introduce-content-img{
    text-align: center;
  }
  .mstation-introduce-content-img-png{
    margin-top: 20px;
    width: 100%;
  }

  @media screen and (max-width:482px) {
    .mstation-introduce-container{
      max-width: 100%;
    }
  }
  @media screen and (min-width:482px) and (max-width:768px) {
    .mstation-introduce-container{
      max-width: 450px;
    }
  }
  @media screen and (min-width:768px) and (max-width:1100px) {
    .mstation-introduce-container{
      max-width: 736px;
    }
  }
  @media screen and (min-width:1100px) and (max-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }
  @media screen and (min-width:1444px) {
    .mstation-introduce-container{
      max-width: 1068px;
    }
  }

</style>